import {State} from '../index'

export const getCommonState = (state: State) => state.common

export const getLoading = (state: State) => getCommonState(state).loading
export const getTableLoading = (state: State) => getCommonState(state).tableLoading
export const getIsRtl = (state: State) => getCommonState(state).isRtl
export const getSnackbar = (state: State) => getCommonState(state).snackbar
export const getTables = (state: State) => getCommonState(state).tables
